 <template> 
 <div>                  
    <b-card class="shadow mt-2">
    <b-form @submit="onSubmit" v-if="show">

        <h4> Information importante en relation avec le COVID-19 </h4>
        <h5 style="color: red;"> Questionnaire obligatoire </h5>
        <hr>

        <b-form-group id="input-group-2" :label="display.firstname + ':'" label-for="input-2">
            <b-form-input
            id="input-2"
            v-model="form.firstname"
            required
            :placeholder="display.firstName"
            ></b-form-input>            
        </b-form-group>

         <b-form-group id="input-group-2b" :label="display.lastname + ':'" label-for="input-2b">
            <b-form-input
            id="input-2b"
            v-model="form.lastname"
            required
            :placeholder="display.lastName"
            ></b-form-input>            
        </b-form-group>

        <!-- <b-form-group id="input-group-4">
            <label for="datepicker">{{ $t('requestappt.q3') }}</label>
            <b-form-datepicker id="datepicker" v-model="form.date" class="mb-2" :placeholder="display.enterDate"></b-form-datepicker>
        </b-form-group>     -->

        <b-form-group id="input-group-3" :label="display.phone + ':'" label-for="input-3">
            <b-form-input
            id="input-3"
            v-model="form.phone"    
            required
            :placeholder="display.enterPhone"
            ></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-email"
            :label="display.email+ ':'"
            label-for="input-email"
        >
            <b-form-input
            id="input-email"
            v-model="form.email"
            type="email"
            required
            :placeholder="display.enterEmail"
            ></b-form-input>
        </b-form-group>  

        <hr>


        <b-form-group 
        id="input-group-5"
        :label="display.q1"
       >
            <b-form-radio-group id="checkboxes-5"  size="lg" stacked>
            <b-form-radio 
                v-for="(s,index) in display.q1a"
                v-model="form.q1a" 
                :key="index" 
                :value="s"         
                > {{s}}                                
            </b-form-radio>
            </b-form-radio-group> 
        </b-form-group>                           

        <b-form-group 
        id="input-group-6"
        :label="display.q2"
       >
            <b-form-radio-group id="checkboxes-6"  size="lg" stacked>
            <b-form-radio 
                v-for="(s,index) in display.q2a"
                v-model="form.q2a" 
                :key="index" 
                :value="s"         
                > {{s}}                                
            </b-form-radio>
            </b-form-radio-group> 
        </b-form-group>   

        <b-form-group 
        id="input-group-7"
        :label="display.q3"
       >
            <b-form-radio-group id="checkboxes-7"  size="lg" stacked>
            <b-form-radio 
                v-for="(s,index) in display.q3a"
                v-model="form.q3a" 
                :key="index" 
                :value="s"         
                > {{s}}                                
            </b-form-radio>
            </b-form-radio-group> 
        </b-form-group>           
      

        <b-form-group 
        id="input-group-8"
        :label="display.q4"
       >
            <b-form-checkbox-group id="checkboxes-8"  size="lg" stacked>
            <b-form-checkbox 
                v-for="(s,index) in display.q4a"
                v-model="form.q4a" 
                :key="index" 
                :value="s"         
                > {{s}}                                
            </b-form-checkbox>
            </b-form-checkbox-group> 
        </b-form-group>     

        <b-form-group 
        id="input-group-9"
        :label="display.q5"
       >
            <b-form-radio-group id="checkboxes-9"  size="lg" stacked>
            <b-form-radio 
                v-for="(s,index) in display.q5a"
                v-model="form.q5a" 
                
                :key="index" 
                :value="s"         
                > {{s}}                                
            </b-form-radio>
            </b-form-radio-group> 
        </b-form-group>   

        <b-form-group 
        id="input-group-10"
        :label="display.q6"
       >
            <b-form-checkbox-group id="checkboxes-10"  size="lg" stacked>
            <b-form-checkbox 
                v-for="(s,index) in display.q6a"
                v-model="form.q6a" 
                :key="index" 
                multiple
                :value="s"         
                > {{s}}                                
            </b-form-checkbox>
            </b-form-checkbox-group> 
        </b-form-group>   

        <hr>

        <h4>Merci de votre collaboration</h4>
        <p>Nous vous prions de bien vouloir suivre nos protocoles de contrôles des infections lors de votre visite. 
            Respecter l'hygiène des mains, apportez votre propre masque (couvre-visage) si possible et suivre l'étiquette respiratoire. 
            Vous êtes invité(e) à apporter votre propre bouteille d'eau au besoin car nous ne pouvons plus servir de breuvages.</p>        

        <hr>

        <h4>Responsabilité</h4>
        <p>En soumettant ce questionnaire, je déclare avoir répondu au questionnaire au meilleur de ma connaissance. 
            Il est de ma responsabilité d'aviser l'esthéticienne/électrolyste/technicienne de tout changement.</p>        

        <hr>
        <hr>

        <b-button type="submit"  squared variant="dark">{{$t('common.submit')}}</b-button>
        </b-form>
    </b-card>

    <b-card v-if="!show">
        <h4>Merci / Thank You</h4>
    </b-card>
</div>
</template>


<script>

const enData = {
    firstname:'First Name',
    lastname:' Last Name',
    email:'Email',
    phone:'Phone Number',
    notes: 'Notes For Us',
    times: ['morning', 'afternoon', 'evening'],
    enterNotes: "Type here...",
    enterDate: "No Date Selected",
    enterName: "Enter Name",
    enterEmail: "Enter Email",
    enterPhone: "Enter Phone Number",
    q1:"Avez-vous voyagé à l'extérieur du pays dans les 15 derniers jours?",
    q1a:['Oui', 'Non'],
    q2:"Avez-vous été en contact avec une personne qui a voyagé à l'extérieur du pays dans les 15 derniers jours?",
    q2a: ['Oui', 'Non'],
    q3: "Avez-vous été en contact avec une personne infectée de la COVID-19 dans les 15 derniers jours?",
    q3a: ['Oui', 'Non'],
    q4: "Avez-vous l'un des symptômes suivants:",
    q4a: ["Toux", "Rhume", "Grippe","Fièvre", "Infection saisonnières","Pneumonie","Difficulté à respirer", "Perte soudaine de l'odorat sans congestion nasale ou sans perte de goût"],
    q5: "SI oui, avez vous consulté un médecin?",
    q5a: ['Oui', 'Non'],
    q6: "Éprouvez-vous l'un des symptômes suivants qui ne sont pas liés à une cause connue, (par exemple arthrite, allergies, blessures récentes, etc.)",
    q6a: ["Mal de gorge","Mal de tête","Douleurs musculaires","Fatigue intense","Nez qui coule","Perte importante de l'appétit","Diharrée"]
}

const frData = {
    firstname:'Prénom',
    lastname:'Nom',
    email:'Courriel',
    phone:'Numéro de téléphone',
    notes: 'Notes pour notre équipe',
    times: ['Matin', 'Après-midi', 'Soir'],
    enterNotes: "Écrivez ici...",
    enterDate: "Aucune date sélectionnée",
    enterName: "Entrez le nom",
    enterEmail: "Entrez votre e-mail",
    enterPhone: "Entrez le téléphone",
    q1:"Avez-vous voyagé à l'extérieur du pays dans les 15 derniers jours?",
    q1a:['Oui', 'Non'],
    q2:"Avez-vous été en contact avec une personne qui a voyagé à l'extérieur du pays dans les 15 derniers jours?",
    q2a: ['Oui', 'Non'],
    q3: "Avez-vous été en contact avec une personne infectée de la COVID-19 dans les 15 derniers jours?",
    q3a: ['Oui', 'Non'],
    q4: "Avez-vous l'un des symptômes suivants:",
    q4a: ["Toux", "Rhume", "Grippe","Fièvre", "Infection saisonnières","Pneumonie","Difficulté à respirer", "Perte soudaine de l'odorat sans congestion nasale ou sans perte de goût"],
    q5: "Si oui, avez vous consulté un médecin?",
    q5a: ['Oui', 'Non'],
    q6: "Éprouvez-vous l'un des symptômes suivants qui ne sont pas liés à une cause connue, (par exemple arthrite, allergies, blessures récentes, etc.)",
    q6a: ["Mal de gorge","Mal de tête","Douleurs musculaires","Fatigue intense","Nez qui coule","Perte importante de l'appétit","Diharrée"]
}


export default {
    data () {
        return {
            show: true,
            display:'',
            form: {
                firstname: '',
                lastname: '',
                email:'',
                phone: '',
                date: '',
                q1:'',
                q1a:[],
                q2:'',
                q2a:[],
                q3:'',
                q3a:[],
                q4:'',
                q4a:[],
                q5:'',
                q5a:[],
                q6:'',
                q6a:[],
                },
        }
},
methods: {
    onSubmit(evt) {
        evt.preventDefault()
        // let data = (JSON.stringify(this.form))
        this.form.date =  new Date (this.form.date)
        let data = Object.assign({}, this.form);
        axios.post('https://beauteintegrale.ca/api/forms', data)
            .then(resp => {
                this.show = false;
            })
            .catch(function (error) {
                console.log(error);
            });
      },
    getData(){
        if (this.$i18n.locale == 'fr'){
          this.display = frData;
        }
        else this.display = enData
    }
  },
  computed: {
      locale(){
          return this.$i18n.locale
      },
      answers(){
          console.log(this.form.questions)
      }
  },
  mounted() { 
      this.getData()   
  },
  watch: {
      locale: function (newLocale, oldLocale) {
        this.getData()
      }
    },
}

</script>
<style scoped>
h4 {
    font-weight: 700;
}
.b{
    font-weight: 700 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/FormCovid.vue